module.exports = __webpack_public_path__ + "static/pergola-4-e499cdd9dfb0bb0e6b20d4a892705d50.jpg";